import api from './api';

// 学生违纪记录API
export const studentViolationsAPI = {
  // 获取违纪记录列表
  getViolations: (params = {}) => {
    return api.get('/student-violations', { params });
  },

  // 获取违纪记录详情
  getViolationDetail: (id) => {
    return api.get(`/student-violations/${id}`);
  },

  // 创建违纪记录
  createViolation: (data) => {
    const formData = new FormData();

    // 添加基本字段
    Object.keys(data).forEach(key => {
      if (key !== 'attachments') {
        formData.append(key, data[key]);
      }
    });

    // 添加附件文件
    if (data.attachments && data.attachments.length > 0) {
      data.attachments.forEach(file => {
        formData.append('attachments', file.originFileObj || file);
      });
    }

    return api.post('/student-violations', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 更新违纪记录
  updateViolation: (id, data) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      if (key !== 'newAttachments' && key !== 'removeAttachments') {
        formData.append(key, data[key]);
      }
    });

    if (data.newAttachments && data.newAttachments.length > 0) {
      data.newAttachments.forEach(file => {
        formData.append('newAttachments', file.originFileObj || file);
      });
    }

    if (data.removeAttachments) {
      formData.append('removeAttachments', JSON.stringify(data.removeAttachments));
    }

    return api.put(`/student-violations/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 删除违纪记录
  deleteViolation: (id) => {
    return api.delete(`/student-violations/${id}`);
  },
};

// 学生表扬记录API
export const studentPraiseAPI = {
  // 获取表扬记录列表
  getPraise: (params = {}) => {
    return api.get('/student-praise', { params });
  },

  // 获取表扬记录详情
  getPraiseDetail: (id) => {
    return api.get(`/student-praise/${id}`);
  },

  // 创建表扬记录
  createPraise: (data) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      if (key !== 'attachments') {
        formData.append(key, data[key]);
      }
    });

    if (data.attachments && data.attachments.length > 0) {
      data.attachments.forEach(file => {
        formData.append('attachments', file.originFileObj || file);
      });
    }

    return api.post('/student-praise', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 更新表扬记录
  updatePraise: (id, data) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      if (key !== 'newAttachments' && key !== 'removeAttachments') {
        formData.append(key, data[key]);
      }
    });

    if (data.newAttachments && data.newAttachments.length > 0) {
      data.newAttachments.forEach(file => {
        formData.append('newAttachments', file.originFileObj || file);
      });
    }

    if (data.removeAttachments) {
      formData.append('removeAttachments', JSON.stringify(data.removeAttachments));
    }

    return api.put(`/student-praise/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 删除表扬记录
  deletePraise: (id) => {
    return api.delete(`/student-praise/${id}`);
  },

  // 获取公开表扬记录
  getPublicPraise: (schoolId, params = {}) => {
    return api.get(`/student-praise/public/${schoolId}`, { params });
  },
};

// 学生积分管理API
export const studentPointsAPI = {
  // 获取积分记录列表
  getPoints: (params = {}) => {
    return api.get('/student-points', { params });
  },

  // 获取学生积分汇总
  getPointsSummary: (studentId) => {
    return api.get(`/student-points/summary/${studentId}`);
  },

  // 手动添加积分记录
  createPoints: (data) => {
    return api.post('/student-points', data);
  },

  // 更新积分记录
  updatePoints: (id, data) => {
    return api.put(`/student-points/${id}`, data);
  },

  // 删除积分记录
  deletePoints: (id) => {
    return api.delete(`/student-points/${id}`);
  },

  // 获取班级积分排行榜
  getClassRanking: (classId, params = {}) => {
    return api.get(`/student-points/ranking/${classId}`, { params });
  },

  // 获取全校积分排行榜
  getSchoolRanking: (schoolId, params = {}) => {
    return api.get(`/student-points/school-ranking/${schoolId}`, { params });
  },

  // 获取学校积分统计
  getSchoolStats: (schoolId) => {
    return api.get(`/student-points/school-stats/${schoolId}`);
  },
};

// 学生作业管理API
export const studentHomeworkAPI = {
  // 获取作业记录列表
  getHomework: (params = {}) => {
    return api.get('/student-homework', { params });
  },

  // 获取作业记录详情
  getHomeworkDetail: (id) => {
    return api.get(`/student-homework/${id}`);
  },

  // 创建作业记录
  createHomework: (data) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      if (key !== 'attachments') {
        formData.append(key, data[key]);
      }
    });

    if (data.attachments && data.attachments.length > 0) {
      data.attachments.forEach(file => {
        formData.append('attachments', file.originFileObj || file);
      });
    }

    return api.post('/student-homework', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 更新作业记录
  updateHomework: (id, data) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      if (key !== 'newAttachments' && key !== 'removeAttachments') {
        formData.append(key, data[key]);
      }
    });

    if (data.newAttachments && data.newAttachments.length > 0) {
      data.newAttachments.forEach(file => {
        formData.append('newAttachments', file.originFileObj || file);
      });
    }

    if (data.removeAttachments) {
      formData.append('removeAttachments', JSON.stringify(data.removeAttachments));
    }

    return api.put(`/student-homework/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 删除作业记录
  deleteHomework: (id) => {
    return api.delete(`/student-homework/${id}`);
  },

  // 获取作业统计信息
  getHomeworkStats: (schoolId) => {
    return api.get(`/student-homework/stats/${schoolId}`);
  },
};

// 学生成绩管理API
export const studentGradesAPI = {
  // 获取成绩记录列表
  getGrades: (params = {}) => {
    return api.get('/student-grades', { params });
  },

  // 获取成绩记录详情
  getGradeDetail: (id) => {
    return api.get(`/student-grades/${id}`);
  },

  // 创建成绩记录
  createGrade: (data) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      if (key !== 'attachments') {
        formData.append(key, data[key]);
      }
    });

    if (data.attachments && data.attachments.length > 0) {
      data.attachments.forEach(file => {
        formData.append('attachments', file.originFileObj || file);
      });
    }

    return api.post('/student-grades', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 更新成绩记录
  updateGrade: (id, data) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      if (key !== 'newAttachments' && key !== 'removeAttachments') {
        formData.append(key, data[key]);
      }
    });

    if (data.newAttachments && data.newAttachments.length > 0) {
      data.newAttachments.forEach(file => {
        formData.append('newAttachments', file.originFileObj || file);
      });
    }

    if (data.removeAttachments) {
      formData.append('removeAttachments', JSON.stringify(data.removeAttachments));
    }

    return api.put(`/student-grades/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 删除成绩记录
  deleteGrade: (id) => {
    return api.delete(`/student-grades/${id}`);
  },

  // 获取成绩统计信息
  getGradeStats: (schoolId) => {
    return api.get(`/student-grades/stats/${schoolId}`);
  },

  // 获取班级成绩排行榜
  getClassRanking: (classId, params = {}) => {
    return api.get(`/student-grades/ranking/${classId}`, { params });
  },

  // 批量导入成绩
  batchImport: (data) => {
    const formData = new FormData();
    for (const key in data) {
      if (key === 'file' && data[key]) {
        formData.append('file', data[key].originFileObj);
      } else {
        formData.append(key, data[key]);
      }
    }
    return api.post('/student-grades/batch-import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // 下载导入模板(带班级学生数据)
  downloadTemplate: (classId) => {
    return api.get('/student-grades/download-template', {
      params: { classId },
      responseType: 'blob'
    });
  },

  // 导出成绩记录
  exportRecords: (params = {}) => {
    return api.get('/student-grades/export', {
      params,
      responseType: 'blob'
    });
  }
};

// 学生考勤管理API
const attendanceAPI = {
  // 获取考勤记录列表
  getRecords: (params = {}) => {
    return api.get('/attendance/records', { params });
  },

  // 提交考勤记录（桌面客户端使用）
  submitRecord: (data) => {
    return api.post('/attendance/record', data);
  },

  // 获取班级操作码列表
  getOperatorCodes: (classId) => {
    return api.get(`/attendance/codes/${classId}`);
  },

  // 创建操作码
  createOperatorCode: (data) => {
    return api.post('/attendance/codes', data);
  },

  // 更新操作码
  updateOperatorCode: (id, data) => {
    return api.put(`/attendance/codes/${id}`, data);
  },

  // 删除操作码
  deleteOperatorCode: (id) => {
    return api.delete(`/attendance/codes/${id}`);
  },

  // 获取考勤统计
  getStatistics: (params = {}) => {
    return api.get('/attendance/statistics', { params });
  },

  // 获取指定日期班级考勤详情
  getDailyAttendance: (classId, date, params = {}) => {
    return api.get(`/attendance/daily/${classId}/${date}`, { params });
  },
};

const studentGrowthAPI = {
  getOverview: (studentId) => {
    return api.get(`/student-growth/overview/${studentId}`);
  },

  getConversations: (params = {}) => {
    return api.get('/student-growth/conversations', { params });
  },

  createConversation: (data) => {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      if (key === 'attachments') {
        return;
      }

      const value = data[key];
      if (Array.isArray(value)) {
        formData.append(key, JSON.stringify(value));
      } else if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    if (data.attachments && data.attachments.length > 0) {
      data.attachments.forEach((file) => {
        formData.append('attachments', file.originFileObj || file);
      });
    }

    return api.post('/student-growth/conversations', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  deleteConversation: (id) => {
    return api.delete(`/student-growth/conversations/${id}`);
  },

  getClassMeetings: (params = {}) => {
    return api.get('/student-growth/class-meetings', { params });
  },

  createClassMeeting: (data) => {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      if (key === 'attachments') {
        return;
      }

      const value = data[key];
      if (Array.isArray(value)) {
        formData.append(key, JSON.stringify(value));
      } else if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    if (data.attachments && data.attachments.length > 0) {
      data.attachments.forEach((file) => {
        formData.append('attachments', file.originFileObj || file);
      });
    }

    return api.post('/student-growth/class-meetings', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  deleteClassMeeting: (id) => {
    return api.delete(`/student-growth/class-meetings/${id}`);
  }
};

const studentAPI = {
  violations: studentViolationsAPI,
  praise: studentPraiseAPI,
  points: studentPointsAPI,
  homework: studentHomeworkAPI,
  grades: studentGradesAPI,
  attendance: attendanceAPI,
  growth: studentGrowthAPI,
};

export default studentAPI;
